class DeleteConfirmationCtrl {

    constructor($scope, $uibModalInstance) {

        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;

        this.$scope.ok = this.ok.bind(this);
        this.$scope.cancel = this.cancel.bind(this);

    }

    ok() {
        this.$uibModalInstance.close();
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

}

angular.module("cpm")
    .controller("DeleteConfirmationCtrl", ['$scope', '$uibModalInstance', DeleteConfirmationCtrl]);


